import {Injectable} from '@angular/core';
import {UserService} from './user.service';
import {StateStorageService} from './state-storage.service';
import {ActivatedRouteSnapshot, Router} from '@angular/router';

@Injectable()
export class RouterAuthService {

    constructor(
        private stateStorageService: StateStorageService,
        private router: Router,
        private userService: UserService
    ) {}


    authorize(route: ActivatedRouteSnapshot): Promise<boolean> {
        return this.userService.getIsAuthenticated(true).toPromise().then(isAuthenticated => {
            let url = route.pathFromRoot.map(r => r.url.join('/')).join('/');
            let data = Object.assign({}, ...route.pathFromRoot.map(r => r.data));

            if (!isAuthenticated && data.needAuthentication) {
                // user is not authenticated. Save the state they wanted before you
                // send them to the login service, so you can return them when you're done
                this.stateStorageService.storePreviousState(url);
                // now, send them to the signin state so they can log in
                this.router.navigate(['/authentication']);
                return false;
            }

            // an authenticated user can't access to login and register pages
            if (isAuthenticated &&
                (url.indexOf('/register') === 0 || url.indexOf('/authentication') === 0)) {
                this.router.navigate(['accueil']);
                return false;
            }

            return true;
        });

    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/router-auth.service.ts